<template>
    <v-dialog v-model="dialog" @click:outside="closeModal">
        <v-card class="custom-card pb-120" rounded="0">
            <v-toolbar flat color="secondary" class="white--text">
                <v-toolbar-title class="font-weight-bold">{{ $t("Ungrouped Animals")}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="pt-5">
                <div class="d-flex mb-4">
                    <h3 class="black--text">Select Animal</h3>
                    <v-spacer></v-spacer>
                </div>
                <v-tabs class="mb-5" v-model="tab">
                    <v-tab class="text-capitalize" @click="type=''" >{{ $t("animal.all") }} ({{ animalCounts.all }})</v-tab>
                    <v-tab class="text-capitalize" @click="type='male'">{{ $t("animal.male") }} ({{ animalCounts.male }})</v-tab>
                    <v-tab class="text-capitalize" @click="type='female'">{{ $t("animal.female") }} ({{ animalCounts.female }})</v-tab>
                </v-tabs>
                <v-data-table
                    :headers="headers"
                    :loading="$apollo.loading"
                    :loading-text="$t('animal.loadingAnimals')"
                    :items="getAnimals"
                    :options.sync="tableOptions"
                    show-select
                    item-key="id"
                    v-model="selected"
                    :server-items-length="totalCount"
                    hide-default-footer
                    class="elevation-1"
                >
                <template v-slot:top>
                    <div class="d-flex mt-5">
                    <v-text-field
                        prepend-inner-icon="mdi-magnify"
                        outlined
                        :placeholder="$t('search')"
                        dense
                        v-model="search"
                        class="shrink"
                    >
                    </v-text-field>
                    <!-- <v-btn
                        :disabled="search.length < 1"
                        color="primary"
                        height="40"
                        width="40"
                        max-width="40"
                        outlined
                        class="ml-8"
                        @click="searchAnimals"
                    >
                        <v-icon>mdi-filter-outline</v-icon>
                    </v-btn> -->
                <v-spacer></v-spacer>
                <div class="py-3">
                    {{  (tableOptions.page - 1) * tableOptions.itemsPerPage + 1 }} -
                    {{
                        tableOptions.page * tableOptions.itemsPerPage -
                    (tableOptions.itemsPerPage - count)
                    }}
                    of {{ totalCount }}
                </div>
                <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="tableOptions.page == 1"
                    @click="pageChange(false)"
                >
                    <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="
                    (tableOptions.page - 1) * tableOptions.itemsPerPage +
                        count >=
                    totalCount
                    "
                    @click="pageChange(true)"
                >
                    <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
            </div>
                </template>


              <template v-slot:item.status="{ item }">
                <v-btn
                  outlined
                  :color="getStatusColor(item.status)"
                  rounded
                  small
                  depressed
                >
                  {{ item.status }}
                </v-btn>
              </template>
                </v-data-table>
                <v-card-actions class="mt-5">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" outlined depressed @click="closeModal">Cancel</v-btn>
                    <v-btn color="primary" depressed @click="moveAnimalToGroup" :disabled="selected.length<1">Move to Group</v-btn>
                </v-card-actions>
            </v-card-text>
        </v-card>
    </v-dialog>
  </template>
  
  <script>
  import loadingMixin from "@/mixins/LoadingMixin";
  import generalMixin from "@/mixins/GeneralMixin";
  import gql from "graphql-tag"
  import { assignAnimalsToGroup } from "@/graphql/Animals.gql"
  
  export default {
    apollo: {
        ungrouppedAnimal: {
            query: gql`
                query ungrouppedAnimal(
                $search: String
                $type: String
                $page: Float
                $limit: Float   
            ) {
                ungrouppedAnimal(
                    search: $search
                    type: $type
                    page: $page
                    limit: $limit
                ) {
                    count
                    rows {
                        id
                        animalIdentification {
                            id
                            dateOfRegistration
                            govRegistrationNo
                            livestockName
                            identificationMethods {
                                additionalIdentificationMethodId
                                idNumber
                                chipNumber
                                tagNumber
                                tatooName
                                brandName
                                code
                                position
                                tagCategoryId
                                tagColor
                                imageUrl
                            }
                    }
                    birthOrigin {
                        id
                        dateOfBirth
                    }
                    breed {
                        name
                        id
                    }
                    breedName
                    additionalInformation {
                        id
                        gender
                        animalPicture
                    }
                    gender
                    status
                    removalInformation {
                        id
                        reasonForRemoval
                    }
                }
            totalCount
          }
        }
      `,
      variables() {
        return {
          type: this.type,
          search: this.search,
          page: this.tableOptions.page,
          limit: this.tableOptions.itemsPerPage,
        };
      },
      fetchPolicy: "network-only",
      skip: () => false,
      update: (data) => data.ungrouppedAnimal.rows,
      result({ data }) {
        this.totalCount = data.ungrouppedAnimal.totalCount;
        this.count = data.ungrouppedAnimal.count;
      },
        },
        animalCounts: {
            query: gql`
                query getCountUngroupped {
                    getCountUngroupped{
                        all,
                        male,
                        female
                    }
                }
            `,
            update: (res) => res.getCountUngroupped
        }
    },
    computed: {
        dialog() {
            return this.dialogU;
        },
        loadingGQL() {
            return this.$apollo.loading 
        },
        getAnimals() {
            return this.ungrouppedAnimal.map((animal) => {
                return {
                    animalNumber: animal.animalIdentification?.livestockName,
                    breedId: animal.breed?.name || animal.breedName,
                    dob: animal.birthOrigin?.dateOfBirth,
                    gender: animal.gender,
                    id: Number(animal.id),
                    regDate: animal.animalIdentification
                        ? animal.animalIdentification.dateOfRegistration
                        : "",
                    status:
                        animal.removalInformation &&
                        animal.removalInformation.reasonForRemoval
                        ? animal.removalInformation.reasonForRemoval
                        : animal.status,
                    tagNumber:
                        animal.animalIdentification &&
                        animal.animalIdentification.identificationMethods
                        ? animal.animalIdentification.identificationMethods
                            .map(
                                (identification) =>
                                identification.idNumber ||
                                identification.chipNumber ||
                                identification.tagName ||
                                identification.code ||
                                identification.brandName
                            )
                            .join(", ")
                        : "",
                };
            });
        },
    },
    watch: {
        type: {
            handler() {
                this.tableOptions.page = 1;
                this.$apollo.queries.animals.skip = false;
                this.$apollo.queries.animals.refetch();
            },
            deep: true
        }
        // loadingGQL: {
        //     handler(v) {
        //         if(v) {
        //             this.startLoading()
        //         }else{
        //             this.stopLoading()
        //         }
        //     }
        // }
    },
    data() {
      return {
        animalCounts: {
            all: 0,
            male: 0,
            female: 0
        },
        selected: [],
        type: "",
        animals: [],
        tab: 0,
        tableOptions: {},
        search: "",
        valid: true,
        zone: null,
        newZonename: "",
        loading: false,
        totalCount: 0,
        count: 0,
        headers: [
        {
          text: this.$t("id"),
          align: "start",
          sortable: true,
          value: "id",
          width: "90px",
        },
        {
          text: this.$t("animal.tag") + " #",
          sortable: true,
          value: "tagNumber",
          width: "120px",
        },
        {
          text: this.$t("animal.dateOfBirth"),
          value: "dob",
          sortable: true,
          width: "140px",
        },
        {
          text: this.$t("animal.gender"),
          sortable: true,
          value: "gender",
          width: "120px",
        },
        {
          text: this.$t("animal.breed"),
          value: "breedId",
          sortable: true,
          width: "120px",
        },
        {
          text: this.$t("animal.regDate"),
          value: "regDate",
          sortable: false,
          width: "140px",
        },
        {
          text: this.$t("Status"),
          value: "status",
          sortable: true,
          width: "120px",
        },
        {
          text: "",
          value: "actions",
          sortable: true,
          width: "120px",
        },
        ],
      };
    },
    methods: {
        getStatusColor(status) {
            if(status == 'slaughter')
                return 'red'
            else if(status == 'movedToAnotherFarm')
                return 'primary'
            else if(status == 'sale')
                return 'warning'
            else if(status == 'death')
                return 'gray'
            else 
                return 'primary'
        },
        pageChange(t) {
            if (t) this.tableOptions.page = this.tableOptions.page + 1;
            else this.tableOptions.page = this.tableOptions.page - 1;

            this.$apollo.queries.animals.skip = false;
            this.$apollo.queries.animals.refetch();
        },
        searchAnimals() {
            // if (this.search == "") return;
            this.tableOptions.page = 1;
            this.$apollo.queries.animals.refetch();
        },
        resetSearchOnEmpty() {
            if (this.search != "") return;
            this.tableOptions.page = 1;
            this.$apollo.queries.animals.refetch();
        },
        moveAnimalToGroup() {
            let animalIds = this.selected.map(({ id }) => id)
            this.assignAnimals(animalIds)
        },
        assignAnimals(animalIds) {
            this.startLoading()
            const mutationData = {}
                mutationData.mutation = assignAnimalsToGroup
                mutationData.variables =  {
                    assignAnimalsToGroup: {
                        groupId: Number(this.group.id), 
                        animalIds: animalIds
                    }
                }

            this.$apollo.mutate(mutationData)
            .then(res => {
                console.log(res)
                this.closeModal(true)
                this.stopLoading()
            })
            .catch( () => {
                this.stopLoading()
            })
        },
        closeModal(success=null) {
            this.$emit("modal-closed", success);
        },
    },
    props: {
        dialogU: {
            type: Boolean,
            required: true,
        },
        group: {
            type: Object,
            required: true,
        }
    },
    mixins: [loadingMixin, generalMixin]
  };
  </script>
